import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '@tsgecart/config';
import { formatPaise } from '../../../../lib/format.js';
import type { CartView } from '../types/cart.js';

export interface MobileStickySummaryProps {
  cart: CartView;
}

/** Bottom-fixed bar (small viewports only, via `sm:hidden`) so checkout stays reachable while scrolling a long cart -- item count + subtotal + checkout button, no other totals since only `subtotalPaise` exists on this view. */
export function MobileStickySummary({ cart }: MobileStickySummaryProps) {
  const disabled = cart.items.length === 0 || cart.hasBlockingIssues;

  return (
    <div
      data-testid="mobile-sticky-summary"
      className="fixed inset-x-0 bottom-0 z-20 flex items-center justify-between gap-3 border-t border-gray-200 bg-white px-4 py-3 shadow-[0_-2px_8px_rgba(0,0,0,0.06)] sm:hidden"
    >
      <div className="min-w-0">
        <p className="text-xs text-gray-500">{cart.itemCount} item{cart.itemCount === 1 ? '' : 's'}</p>
        <p className="text-sm font-semibold text-gray-900">{formatPaise(cart.subtotalPaise)}</p>
      </div>
      <Link
        to={ROUTE_NAMES.checkout}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : undefined}
        onClick={(event) => {
          if (disabled) event.preventDefault();
        }}
        className={`focus-visible:ring-brand shrink-0 rounded-full px-5 py-2.5 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 ${
          disabled
            ? 'pointer-events-none cursor-not-allowed bg-gray-200 text-gray-400'
            : 'bg-gray-900 text-white hover:bg-gray-800'
        }`}
      >
        Checkout
      </Link>
    </div>
  );
}
